import { TextField } from '@mui/material';
import { useGridApiContext } from '@mui/x-data-grid-premium';

/** LOT·날짜 셀 편집. 진입 즉시 입력 가능하고 Enter로 다음 행 같은 칸으로 내려가 연속 입력이 빠르다. */
export default function LotEditCell({ id, field, value, type = 'text', maxLength }) {
    const apiRef = useGridApiContext();
    return (
        <TextField
            autoFocus
            size="small"
            type={type}
            value={value ?? ''}
            inputProps={maxLength ? { maxLength } : undefined}
            onChange={(e) => apiRef.current.setEditCellValue({ id, field, value: e.target.value || null })}
            onKeyDown={(e) => {
                if (e.key === 'Enter') {
                    e.stopPropagation();
                    apiRef.current.stopCellEditMode({ id, field });
                    const ids = apiRef.current.getAllRowIds();
                    const next = ids[ids.indexOf(id) + 1];
                    if (next !== undefined) {
                        apiRef.current.setCellFocus(next, field);
                        apiRef.current.startCellEditMode({ id: next, field });
                    }
                }
            }}
            sx={{ width: '100%', '& input': { fontSize: 11, py: 0.5 } }}
        />
    );
}
